import axios from 'axios'
import { apiUrl } from '../constants'

const baseUrl = apiUrl

const mailLink = "info@instalevel.org"
const resetUrl = 'https://b2b.instalevel.org/new_password'
const confirmUrl = 'https://b2b.instalevel.org/confirm'

axios.defaults.baseURL = baseUrl;
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8'
let userdata = JSON.parse( localStorage.getItem('userdata') ) || false

//HTTP BASIC AUTH
// axios.defaults.headers.common['Authorization'] = 'Basic c2ZtdGVzdDpub2luZGV4'


if ( userdata ) {
  axios.defaults.headers.common['X-User-Uid'] = userdata['uid']
  axios.defaults.headers.common['X-User-Token'] = userdata['token']
}

function reset_axios() {
  let userdata = JSON.parse( localStorage.getItem('userdata') ) || false

  if ( userdata ) {
    axios.defaults.headers.common['X-User-Uid'] = userdata['uid']
    axios.defaults.headers.common['X-User-Token'] = userdata['token']
  } else {
    delete axios.defaults.headers.common['X-User-Uid']
    delete axios.defaults.headers.common['X-User-Token']
  }
}

const updateProgress = (progressEvent) => {
  if (progressEvent.lengthComputable) {
    const { loaded, total } = progressEvent
    const progress = Math.round(loaded/total*100)
    return {
      type: "UPDATE_PROGRESS_BAR",
      payload: progress
    }
  }
}

export { axios, reset_axios, baseUrl, resetUrl, confirmUrl, mailLink, updateProgress }



// WEBPACK FOOTER //
// ./src/js/services/index.js